import PropTypes from 'prop-types';
import React from 'react';
import styled from 'styled-components';
import { rem } from 'polished';

const Wrapper = styled.div`
  height: ${rem(80)};
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  position: relative;
  left: 50%;
  transform: translate(-50%);
`;

const Title = styled.div`
  color: ${({ theme }) => theme.color.font.primary};
  font-size: ${rem(28)};
  text-align: center;
`;

const SectionSeparator = ({ content }) => {
  return (
    <Wrapper>
      <Title>{content}</Title>
    </Wrapper>
  );
};

SectionSeparator.propTypes = {
  content: PropTypes.node.isRequired,
};

export default SectionSeparator;



// WEBPACK FOOTER //
// ./src/components/SectionSeparator/index.js